import * as yup from 'yup';
import { baseFetch } from '../../baseFetch';
import {
  CreatedFeaturesResponseSchema,
  OrgFeaturesResponseSchema,
} from './features.schema';

const AnyResponseSchema = yup.mixed() as unknown as yup.MixedSchema<
  null,
  yup.AnyObject,
  undefined,
  ''
>;

export const getCreatedFeatures = () =>
  baseFetch(
    'internal',
    '/api/v2/feature/created_features',
    CreatedFeaturesResponseSchema,
  );

export const getOrgFeatures = (orgId: number) =>
  baseFetch('internal', '/api/v2/feature/all', OrgFeaturesResponseSchema, {
    searchParams: { org_id: String(orgId) },
  });

export const enableOrgFeature = (orgId: number, featureId: number) =>
  baseFetch(
    'internal',
    `/api/v2/feature/${featureId}/${orgId}/enable_feature` as `/${string}`,
    AnyResponseSchema,
    { method: 'POST' },
  );

export const disableOrgFeature = (orgId: number, featureId: number) =>
  baseFetch(
    'internal',
    `/api/v2/feature/${featureId}/${orgId}/disable_feature` as `/${string}`,
    AnyResponseSchema,
    { method: 'POST' },
  );
